import { DashboardCardContentValue } from '../../../components/DashboardCardContentValue/dashboard-card-content-value';
import { DashboardCardContentValueChange } from '../../../components/DashboardCardContentValueChange/dashboard-card-content-value-change';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { StatsIcon } from '../../../../../components/icons/stats-icon';
import { ConsumptionGraph } from '../../../../../components/graphs/consumption';
import { useTranslation } from 'react-i18next';
import { useGetEosConsumptionSquareMeterQuery } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { useMemo } from 'react';
import { NoDataWidgetContent } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { toNumberString } from '@client/toolkit';

export function EnergyConsumptionKvmWidget() {
  const { t: tWidget } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data, isLoading, isError } = useGetEosConsumptionSquareMeterQuery(
    {
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );

  const { value = 0, percentage = 0, buckets = [] } = data ?? {};

  const graphData = useMemo<any>(() => {
    const safeBuckets = buckets || [];
    return {
      id: 'consumption',
      data: safeBuckets.map((bucket) => ({
        x: bucket.key,
        y: bucket.value,
      })),
    };
  }, [isLoading, buckets]);

  return (
    <DashboardCardWrapper
      to="/reporting/consumption-energy"
      icon={<StatsIcon />}
      title={tWidget('energyConsumptionKvm.title')}
      tooltip=""
      loading={isLoading}
    >
      {(!isLoading || isError) && value === 0 ? (
        <NoDataWidgetContent noDataText={tWidget('energy.noData')} />
      ) : (
        <>
          <div className="flex flex-col gap-2">
            <DashboardCardContentValue value={`${toNumberString(value ?? 0)}`} unit="kWh/m²">
              <DashboardCardContentValueChange value={`${percentage}%`} />
            </DashboardCardContentValue>
          </div>
          <div className="overflow-hidden rounded-b-md absolute bottom-0 left-0 right-0 h-[10em] lg:min-h-auto">
            <ConsumptionGraph data={[graphData]} />
          </div>
        </>
      )}
    </DashboardCardWrapper>
  );
}
